import { RouteConfig } from 'vue-router';

export const contactsChildren: Array<RouteConfig> = [
  {
    path: 'overview',
    name: 'contacts-overview',
    component: (): Promise<typeof import('vue')> =>
      import(/* webpackChunkName: "main" */ '../views/contacts/Contacts.vue')
  },
  {
    path: ':contactId',
    component: (): Promise<typeof import('vue')> =>
      import(/* webpackChunkName: "main" */ '../components/contacts/single-contact/SingleContact.vue'),
    children: [
      {
        path: 'personal-details',
        components: {
          'personal-details': (): Promise<typeof import('vue')> =>
            import(/* webpackChunkName: "main" */ '../components/shared/pass-through/PassThrough.vue')
        },
        children: [
          {
            path: 'view',
            name: 'personal-details-view',
            component: (): Promise<typeof import('vue')> =>
              import(
                /* webpackChunkName: "main" */ '@/components/contacts/single-contact/personal-details/PersonalDetails.vue'
              )
          },
          {
            path: 'edit',
            name: 'personal-details-edit',
            component: (): Promise<typeof import('vue')> =>
              import(
                /* webpackChunkName: "main" */ '@/components/contacts/single-contact/personal-details/personal-details-edit/PersonalDetailsEdit.vue'
              )
          },
          {
            path: '',
            redirect: {
              name: 'personal-details-view'
            }
          }
        ]
      },
      {
        path: 'course-bookings',
        components: {
          'course-bookings': (): Promise<typeof import('vue')> =>
            import(/* webpackChunkName: "main" */ '../components/shared/pass-through/PassThrough.vue')
        },
        children: [
          {
            path: 'overview',
            name: 'course-bookings-overview',
            component: (): Promise<typeof import('vue')> =>
              import(
                /* webpackChunkName: "main" */ '@/components/contacts/single-contact/course-bookings/CourseBookings.vue'
              )
          },
          {
            path: 'booking-details/:courseBookingId',
            name: 'course-booking-details',
            component: (): Promise<typeof import('vue')> =>
              import(
                /* webpackChunkName: "main" */ '../components/contacts/single-contact/course-bookings/course-booking-details/CourseBookingDetails.vue'
              )
          },
          {
            path: '',
            redirect: {
              name: 'course-bookings-overview'
            }
          }
        ]
      },
      {
        path: 'purchase-history',
        name: 'purchase-history',
        components: {
          'purchase-history': (): Promise<typeof import('vue')> =>
            import(
              /* webpackChunkName: "main" */ '@/components/contacts/single-contact/purchase-history/PurchaseHistory.vue'
            )
        }
      },
      {
        path: 'donation-history',
        name: 'donation-history',
        components: {
          'donation-history': (): Promise<typeof import('vue')> =>
            import(
              /* webpackChunkName: "main" */ '@/components/contacts/single-contact/donation-history/DonationHistory.vue'
            )
        }
      },
      {
        path: 'contact-notes',
        name: 'contact-notes',
        components: {
          'contact-notes': (): Promise<typeof import('vue')> =>
            import(/* webpackChunkName: "main" */ '@/components/contacts/single-contact/notes/ContactNotes.vue')
        }
      },
      {
        path: '',
        redirect: {
          name: 'personal-details-view'
        }
      }
    ]
  },
  {
    path: '',
    redirect: {
      name: 'contacts-overview'
    }
  }
];
